import React, { useState } from "react";
import { useEffect } from "react";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import Experience from "./components/experience/Experience";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import Portfolio from "./components/portfolio/Portfolio";
import Services from "./components/services/Services";
import Mode from "./components/switch/Mode";
import Testimonials from "./components/testimonials/Testimonials";
import Text from "./components/text/Text";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    console.log(isDarkMode);
  }, [isDarkMode]);
  return (
    <div className={isDarkMode ? "light-bg" : "dark"}>
      <Mode darkMode={isDarkMode} setDarkMode={setIsDarkMode} />
      <Header darkMode={isDarkMode} />
      <Nav darkMode={isDarkMode} />
      <About darkMode={isDarkMode} />
      <Experience darkMode={isDarkMode} />
      <Services darkMode={isDarkMode} />
      <Portfolio darkMode={isDarkMode} />
      <Contact darkMode={isDarkMode} />
      <Footer darkMode={isDarkMode} />
    </div>
  );
}

export default App;
